import InformationGrayedIcon from "components/common/InformationGrayedIcon";
import LinkButton from "components/common/LinkButton";
import Button from "components/common/controls/Button";

interface Props {
  onViewRequestDataClick: () => void;
  onRefreshDataClick: () => void;
  enabled: boolean;
}

export default function OutputDataRefresher(props: Props) {
  const { enabled, onViewRequestDataClick, onRefreshDataClick } = props;

  const handleViewRequestJsonClicked = () => {
    onViewRequestDataClick();
  };
  
  const handleRefreshDataClicked = () => {
    onRefreshDataClick();
  };

  return (
    <div className="flex justify-between bg-promGray4 px-6 py-3.5 rounded-t">
      <div>
        <div className="flex">
          <InformationGrayedIcon />
          <div className="ml-4 text-sm">
            <div>Process your input data to update the output data below.</div>
            <div>
              <span className="mr-1">
                You can view your complete input data in JSON format:
              </span>
              <LinkButton
                className="text-primaryRed"
                onClick={handleViewRequestJsonClicked}
              >
                request.json
              </LinkButton>
            </div>
          </div>
        </div>
      </div>
      <div>
        <span className="mr-4 font-medium">Update output data:</span>
        <Button
          variant="primary"
          className="px-2"
          disabled={!enabled}
          onClick={handleRefreshDataClicked}
        >
          PROCESS DATA <i className="icon dx-icon-refresh ml-2"></i>
        </Button>
      </div>
    </div>
  );
}
